import { render, staticRenderFns } from "./EstudianteEditar.vue?vue&type=template&id=d79821ea&"
import script from "./EstudianteEditar.vue?vue&type=script&lang=js&"
export * from "./EstudianteEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports